import { NgTemplateOutlet } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { Router } from "@angular/router";
import { CoreButton, CoreIconButton, SvsModalService, TooltipDirective } from "@svs/angular";
import { ChatStore } from "../../../@core/state/chat.store";
import { SettingsModalComponent } from "../../../@shared/settings-modal/settings-modal.component";

@Component({
  selector: "app-sidebar-options",
  imports: [
    CoreButton,
    CoreIconButton,
    NgTemplateOutlet,
    TooltipDirective,
  ],
  templateUrl: "./sidebar-options.component.html",
  styleUrl: "./sidebar-options.component.scss",
})
export class SidebarOptionsComponent {
  readonly store = inject(ChatStore);
  readonly router = inject(Router);
  readonly modal = inject(SvsModalService);
  @Input({ required: true }) compactView!: boolean;

  restart() {
    this.store.reset();
    this.router.navigate([""]);
  }

  openSettings() {
    this.modal.open(SettingsModalComponent);
  }

  openSupport() {
    window.open("https://www.svs.at/cdscontent/?contentid=10007.816878&portal=svsportal", "_blank");
  }
}
